import "./App.css";
import React from "react";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import { createCustomEqual } from "fast-equals";
import { isLatLngLiteral } from "@googlemaps/typescript-guards";
import Nav from "./Nav";
import {
  Spinner,
  getDistanceByKm,
  cleanString,
  closeWindowHandler,
  retroFix,
} from "./helper";

const API = process.env.REACT_APP_API || `${window.origin}/graphql`;

const svgSize = 16;
const svgLabelSizeW = 95;
const svgLabelSizeH = 40;
const svgTransparent =
  "data:image/svg+xml;base64," +
  window.btoa(
    "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 95.3 39.7' enableBackground='new 0 0 95.3 39.7'><rect x='0.5' y='23.2' fill='none' stroke='none' stroke-miterlimit='10' width='94.3' height='16.2'/><circle fill='none' cx='47.6' cy='10.3' r='9.5'/></svg>"
  );

function App() {
  const [apiKey, setApiKey] = React.useState(
    "AIzaSyAh9OHqv3xb00Oxl4FNEh4oEQKj9GMTAOE"
  );
  const [logo, setLogo] = React.useState("");
  const [content, setContent] = React.useState({ __html: "Loading..." });
  const [loading, setLoading] = React.useState(true);
  const [map, setMap] = React.useState();
  const [clicks, setClicks] = React.useState([]);
  const [zoom, setZoom] = React.useState(7);
  const initialCenter = {
    lat: -21.6171376,
    lng: 133.7977352,
  };
  const [center, setCenter] = React.useState(initialCenter);

  const [layers, setLayers] = React.useState({});

  React.useEffect(() => {
    if (
      typeof window !== "undefined" &&
      typeof window.__PRELOADED_CONTENT__ !== "undefined" &&
      typeof window.__PRELOADED_LOGO__ !== "undefined"
    ) {
      typeof window.__API_KEY__ !== "undefined" &&
        setApiKey(window.__API_KEY__);
      typeof window.__MAP_CENTER__ !== "undefined" &&
        setCenter(JSON.parse(window.__MAP_CENTER__));
      setLogo(window.__PRELOADED_LOGO__);
      setContent(JSON.parse(window.__PRELOADED_CONTENT__));
    }

    fetch(API, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: `
            query MyQuery {
              geomap {
                geoLayers {
                  layers {
                    order
                    title
                    type
                    gid
                    group
                    marker
                    json {
                      mediaItemUrl
                    }
                    fill
                    stroke
                    width
                    size
                    color
                    opacity
                    visible
                    link
                  }
                }
              }
            }
          `,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        let arrLayers = response.data.geomap.geoLayers.layers.sort(function (
          a,
          b
        ) {
          return a.order - b.order;
        });

        arrLayers = arrLayers.map((l, i) => {
          return {
            ...l,
            id: i,
            size: l?.size ? l.size + "px" : "14px",
            json: l?.json?.mediaItemUrl ? l.json.mediaItemUrl : null,
          };
        });

        setLayers({ ...Object.assign({}, arrLayers) });
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [setLoading, setContent]);

  const onClick = (e) => {
    setClicks([...clicks, e.latLng]);
  };

  const onIdle = (m) => {
    // console.log("onIdle");
    setZoom(m.getZoom());
    setCenter(m.getCenter().toJSON());
  };

  const onZoomChanged = (m) => {
    // console.log("onZoomChanged");
  };

  const render = (status) => {
    switch (status) {
      case Status.LOADING:
        return <Spinner />;
      case Status.FAILURE:
        return (
          <div className="gm-status">Faild to load. Please contact us</div>
        );
      case Status.SUCCESS:
        return <div className="gm-status">{status}</div>;
      default:
        return <Spinner />;
    }
  };

  const form = (
    <aside>
      <a href="/" className="gm-logo obj">
        <img src={logo} alt="logo" />
      </a>
      <div dangerouslySetInnerHTML={{ __html: content }} />
      <Nav map={map} layers={layers} setLayers={setLayers} />
    </aside>
  );
  return (
    <div className="geomap-wrapper">
      {form}
      <Wrapper apiKey={apiKey} render={render}>
        <Map
          center={center}
          initialCenter={initialCenter}
          onClick={onClick}
          onIdle={onIdle}
          onZoomChanged={onZoomChanged}
          layers={layers}
          setLayers={setLayers}
          clicks={clicks}
          setClicks={setClicks}
          map={map}
          setMap={setMap}
          loading={loading}
          minZoom={6}
          zoom={zoom}
          mapTypeId={"styled_map"}
          mapTypeControlOptions={{
            mapTypeIds: ["styled_map"],
          }}
          disableDefaultUI={true}
          zoomControl={true}
          scaleControl={true}
          rotateControl={true}
          fullscreenControl={false}
          style={{ flexGrow: "1", height: "100%" }}
        >
          {clicks.map((latLng, i) => (
            <Marker key={i} position={latLng} />
          ))}
        </Map>
      </Wrapper>
    </div>
  );
}

const Map = ({
  initialCenter,
  onClick,
  onIdle,
  onZoomChanged,
  layers,
  setLayers,
  clicks,
  setClicks,
  map,
  setMap,
  loading,
  children,
  style,
  ...options
}) => {
  const ref = React.useRef(null);
  // const [map, setMap] = React.useState();
  const [waiting, setWaiting] = React.useState(true);

  function isFullscreen(element) {
    return (
      (window.document.fullscreenElement ||
        window.document.webkitFullscreenElement ||
        window.document.mozFullScreenElement ||
        window.document.msFullscreenElement) === element
    );
  }

  function requestFullscreen(element) {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.webkitRequestFullScreen) {
      element.webkitRequestFullScreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.msRequestFullScreen) {
      element.msRequestFullScreen();
    }
  }

  function exitFullscreen() {
    if (window.document.exitFullscreen) {
      window.document
        .exitFullscreen()
        .then(() => console.info("Document Exited from Full screen mode"))
        .catch((err) => console.error(err));
    } else if (window.document.webkitExitFullscreen) {
      window.document
        .webkitExitFullscreen()
        .then(() => console.info("Document Exited from Full screen mode"))
        .catch((err) => console.error(err));
    } else if (window.document.mozCancelFullScreen) {
      window.document
        .mozCancelFullScreen()
        .then(() => console.info("Document Exited from Full screen mode"))
        .catch((err) => console.error(err));
    } else if (window.document.msExitFullscreen) {
      window.document
        .msExitFullscreen()
        .then(() => console.info("Document Exited from Full screen mode"))
        .catch((err) => console.error(err));
    }
  }

  function FullScreenControl(controlDiv, map) {
    const controlUI = window.document.createElement("div");
    controlUI.className = "gm-fullscreen";
    controlUI.style.backgroundColor = "#fff";
    controlUI.style.width = "40px";
    controlUI.style.height = "40px";
    controlUI.style.borderRadius = "2px";
    controlUI.style.boxShadow = "rgba(0,0,0,.3) 0px 1px 4px -1px";
    controlUI.style.cursor = "pointer";
    controlUI.style.margin = "10px";
    controlUI.style.textAlign = "center";
    controlUI.title = "Click to fullscreen";
    controlDiv.appendChild(controlUI);

    const controlText = window.document.createElement("div");

    controlText.style.color = "rgb(25,25,25)";
    controlText.style.fontSize = "1rem";
    controlText.style.lineHeight = "40px";
    controlText.style.paddingLeft = "5px";
    controlText.style.paddingRight = "5px";
    controlText.innerHTML =
      "<svg version='1.1' width='25px' height='40px' x='0px' y='0px' viewBox='0 0 19.8 19.8'><polygon fill='#686868' points='7.4,2.4 7.4,0.7 0.7,0.7 0.7,7.4 2.4,7.4 2.4,2.4'/><polygon fill='#686868' points='17.4,7.4 19.1,7.4 19.1,0.7 12.4,0.7 12.4,2.4 17.4,2.4'/><polygon fill='#686868' points='2.4,12.3 0.7,12.3 0.7,19.1 7.4,19.1 7.4,17.4 2.4,17.4'/><polygon fill='#686868' points='12.4,17.4 12.4,19.1 19.1,19.1 19.1,12.3 17.4,12.3 17.4,17.4'/></svg>";
    controlUI.appendChild(controlText);
    controlUI.addEventListener("click", (e) => {
      const elementToSendFullscreen = map.getDiv().firstChild;
      if (isFullscreen(elementToSendFullscreen)) {
        exitFullscreen();
      } else {
        requestFullscreen(elementToSendFullscreen);
      }

      window.document.onwebkitfullscreenchange =
        window.document.onmsfullscreenchange =
        window.document.onmozfullscreenchange =
        window.document.onfullscreenchange =
          function () {
            if (isFullscreen(elementToSendFullscreen)) {
              controlUI.classList.add("is-fullscreen");
              document.getElementById("geomap").classList.add("is-fullscreen");
            } else {
              controlUI.classList.remove("is-fullscreen");
              document
                .getElementById("geomap")
                .classList.remove("is-fullscreen");
            }
          };
    });
  }

  function ExitFullScreenControl(controlDiv, map) {
    const controlUI = window.document.createElement("div");
    controlUI.className = "gm-exitfullscreen";
    controlUI.style.backgroundColor = "rgba(0,0,0,0.6)";
    controlUI.style.width = "40px";
    controlUI.style.height = "40px";
    controlUI.style.borderRadius = "40px";
    controlUI.style.boxShadow = "rgba(0,0,0,.3) 0px 1px 4px -1px";
    controlUI.style.cursor = "pointer";
    controlUI.style.margin = "10px";
    controlUI.style.textAlign = "center";
    controlUI.title = "Click to exit fullscreen";
    controlDiv.appendChild(controlUI);

    const controlText = window.document.createElement("div");

    controlText.style.color = "rgb(25,25,25)";
    controlText.style.fontSize = "1rem";
    controlText.style.lineHeight = "40px";
    controlText.style.paddingLeft = "5px";
    controlText.style.paddingRight = "5px";
    controlText.innerHTML =
      "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' width='14px' height='40px' x='0px' y='0px' viewBox='0 0 10.5 10.5' enableBackground='new 0 0 10.5 10.5'><path fill='#FFFFFF' d='M10.5,1l-1-1L5.2,4.3L1,0L0,1l4.3,4.3L0,9.5l1,1l4.3-4.3l4.3,4.3l1-1L6.2,5.2L10.5,1z'/></svg>";
    controlUI.appendChild(controlText);
    controlUI.addEventListener("click", (e) => {
      const elementToSendFullscreen = map.getDiv().firstChild;
      if (isFullscreen(elementToSendFullscreen)) {
        exitFullscreen();
      }

      window.document.onwebkitfullscreenchange =
        window.document.onmsfullscreenchange =
        window.document.onmozfullscreenchange =
        window.document.onfullscreenchange =
          function () {
            if (!isFullscreen(elementToSendFullscreen)) {
              document
                .getElementById("geomap")
                .classList.remove("is-fullscreen");
            }
          };
    });
  }

  function CenterControl(controlDiv, map, center) {
    const controlUI = window.document.createElement("div");
    controlUI.className = "gm-centermap";
    controlUI.style.backgroundColor = "#fff";
    controlUI.style.width = "40px";
    controlUI.style.height = "40px";
    controlUI.style.borderRadius = "2px";
    controlUI.style.boxShadow = "rgba(0,0,0,.3) 0px 1px 4px -1px";
    controlUI.style.cursor = "pointer";
    controlUI.style.margin = "10px";
    controlUI.style.textAlign = "center";
    controlUI.title = "Click to center the map";
    controlDiv.appendChild(controlUI);

    const controlText = window.document.createElement("div");

    controlText.style.color = "rgb(25,25,25)";
    controlText.style.fontSize = "1rem";
    controlText.style.lineHeight = "40px";
    controlText.style.paddingLeft = "5px";
    controlText.style.paddingRight = "5px";
    controlText.innerHTML =
      "<svg version='1.1' width='25px' height='40px' x='0px' y='0px' viewBox='0 0 19.8 19.8' enableBackground='new 0 0 19.8 19.8' xmlSpace='preserve'><path fill='#676767' d='M17.2,5.9c0,0.5,0,1.1,0,1.6c-1.6,0-3.2,0-4.8,0c0,0,0-0.1,0-0.1c0-1.5,0-3.1,0-4.6c0-0.1,0-0.1,0.1-0.1 c0.5,0,0.9,0,1.4,0c0,0,0.1,0,0.1,0c0,0.7,0,1.4,0,2.1c1.4-1.4,2.8-2.8,4.3-4.3c0.4,0.4,0.8,0.8,1.1,1.2C18,3,16.5,4.4,15.1,5.9 c0,0,0,0,0,0C15.8,5.9,16.5,5.9,17.2,5.9z'/><path fill='#676767' d='M2.7,5.9c0.7,0,1.4,0,2.1,0C3.3,4.5,1.9,3,0.5,1.6c0.4-0.4,0.8-0.8,1.2-1.1C3,1.9,4.4,3.3,5.9,4.7 c0,0,0,0,0,0c0-0.7,0-1.4,0-2.1c0,0,0.1,0,0.1,0c0.5,0,0.9,0,1.4,0c0.1,0,0.1,0,0.1,0.1c0,1.6,0,3.1,0,4.7c0,0.1,0,0.1-0.1,0.1 c-1.6,0-3.1,0-4.7,0c-0.1,0-0.1,0-0.1-0.1C2.6,6.9,2.6,6.4,2.7,5.9C2.6,5.9,2.6,5.9,2.7,5.9z'/><path fill='#676767' d='M5.9,17.2c0-0.7,0-1.4,0-2.1C4.5,16.6,3,18,1.6,19.4c-0.4-0.4-0.8-0.8-1.1-1.2c1.4-1.4,2.8-2.8,4.2-4.2 c0,0,0,0,0,0c-0.7,0-1.4,0-2.1,0c0,0,0-0.1,0-0.1c0-0.5,0-0.9,0-1.4c0-0.1,0-0.1,0.1-0.1c1.6,0,3.1,0,4.7,0c0.1,0,0.1,0,0.1,0.1 c0,1.6,0,3.1,0,4.7c0,0,0,0,0,0.1C7,17.2,6.4,17.2,5.9,17.2z'/><path fill='#676767' d='M17.2,12.4c0,0.5,0,1.1,0,1.6c-0.7,0-1.4,0-2.1,0c1.4,1.4,2.8,2.8,4.3,4.3c-0.4,0.4-0.8,0.8-1.2,1.1 c-1.4-1.4-2.8-2.8-4.2-4.2c0,0,0,0,0,0c0,0.7,0,1.4,0,2.1c0,0-0.1,0-0.1,0c-0.5,0-0.9,0-1.4,0c-0.1,0-0.1,0-0.1-0.1 c0-1.5,0-3.1,0-4.6c0,0,0-0.1,0-0.1C14,12.4,15.6,12.4,17.2,12.4z'/><path fill='#CE5F2B' d='M12.3,9.9c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4C11.3,7.5,12.3,8.6,12.3,9.9z '/></svg>";
    controlUI.appendChild(controlText);
    controlUI.addEventListener("click", (e) => {
      map.setCenter(initialCenter);
      map.setZoom(7);
    });
  }

  React.useEffect(() => {
    if (ref.current && !map) {
      setMap(new window.google.maps.Map(ref.current, {}));
    }
  }, [ref, map, setMap, loading]);

  // because React does not do deep comparisons, a custom hook is used
  // see discussion in https://github.com/googlemaps/js-samples/issues/946

  useDeepCompareEffectForMaps(() => {
    if (map) {
      const fullscreenControlDiv = window.document.createElement("div");
      FullScreenControl(fullscreenControlDiv, map);
      map.controls[window.google.maps.ControlPosition.TOP_RIGHT].push(
        fullscreenControlDiv
      );

      const exitFullscreenControlDiv = window.document.createElement("div");
      ExitFullScreenControl(exitFullscreenControlDiv, map);
      map.controls[window.google.maps.ControlPosition.TOP_CENTER].push(
        exitFullscreenControlDiv
      );

      const centerControlDiv = window.document.createElement("div");
      CenterControl(centerControlDiv, map);
      map.controls[window.google.maps.ControlPosition.LEFT].push(
        centerControlDiv
      );
    }
  }, [map, loading]);

  useDeepCompareEffectForMaps(() => {
    if (map) {
      const updatedOptions = {
        ...options,
        zoomControlOptions: {
          position: window.google.maps.ControlPosition.RIGHT,
        },
        fullscreenControlOptions: {
          position: window.google.maps.ControlPosition.RIGHT,
        },
      };

      map.setOptions(updatedOptions);
    }
  }, [map, options]);

  React.useEffect(() => {
    if (map) {
      ["click", "idle"].forEach(
        (eventName) =>
          new window.google.maps.event.clearListeners(map, eventName)
      );

      // if (onClick) {
      //   map.addListener("click", onClick);
      // }

      if (onIdle) {
        map.addListener("idle", () => onIdle(map));
      }

      // if (onZoomChanged) {
      //   map.addListener("zoom_changed", () => onZoomChanged(map));
      // }
    }
  }, [map, onClick, onIdle, onZoomChanged, clicks, setClicks]);

  React.useEffect(() => {
    if (map && !loading) {
      const styledMapType = new window.google.maps.StyledMapType(
        [
          {
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "all",
            elementType: "all",
            stylers: [
              {
                color: "#e57542", // #ce5e2c
              },
              {
                visibility: "on",
              },
            ],
          },
        ],
        { name: "Styled Map" }
      );

      map.mapTypes.set("styled_map", styledMapType);
      map.setMapTypeId("styled_map");

      for (const l in layers) {
        if (layers[l].layer) {
          layers[l].layer.setMap(null);
          // delete layers[l].layer;
        }
      }

      for (const l in layers) {
        const spatialType = layers[l]?.json
          ?.split(/[#?]/)[0]
          ?.split(".")
          ?.pop()
          ?.trim();
        if (layers[l].type.includes("spatial") && spatialType === "geojson") {
          fetch(layers[l].json)
            .then((response) => response.json())
            .then((data) => {
              const geojson = data;
              const geoLayer = new window.google.maps.Data();
              geoLayer.addGeoJson(geojson);
              geoLayer.setStyle({
                title: layers[l].title,
                fillColor: layers[l]?.fill !== null ? layers[l].fill : "none",
                fillOpacity:
                  layers[l]?.opacity !== null ? layers[l].opacity : 0,
                strokeColor:
                  layers[l]?.stroke !== null ? layers[l].stroke : "none",
                strokeOpacity:
                  layers[l]?.opacity !== null && layers[l]?.stroke !== null
                    ? layers[l].opacity
                    : 0,
                strokeWeight: layers[l]?.width !== null ? layers[l].width : 0,
                visible: layers[l].visible,
                zIndex: Number(layers[l].id),
              });

              if (layers[l].type.includes("click")) {
                geoLayer.addListener("click", function (e) {
                  // console.log(e.feature.getProperty("Id"));
                  // setClicks([...clicks, e.latLng]);
                  const featureName = e.feature.getProperty("Name");

                  if (!layers[l].hasOwnProperty("markers")) {
                    layers[l].markers = {};
                  }

                  closeWindowHandler(layers);

                  if (layers[l].type.includes("group")) {
                    const filterKey = layers[l].gid.split("-");

                    if (filterKey.length !== 2) return;

                    for (const l in layers) {
                      if (
                        layers[l].type.includes("filter") &&
                        layers[l].marker === filterKey[0]
                      ) {
                        for (const d in layers[l].data) {
                          if (layers[l].data[d].gid === filterKey[1]) {
                            layers[l].data[d].window.open({
                              anchor: layers[l].data[d].marker,
                              map: map,
                              shouldFocus: false,
                            });
                            break;
                          }
                        }

                        break;
                      }
                    }
                  } else {
                    layers[l].markers.marker = new window.google.maps.Marker({
                      map: map,
                      icon: {
                        path: "M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z",
                        scale: 0.5,
                        fillColor: layers[l].color
                          ? layers[l].color
                          : "#000000",
                        fillOpacity: 0.7,
                        strokeColor: layers[l].color
                          ? layers[l].color
                          : "#000000",
                        strokeOpacity: 1,
                        strokeWeight: 1,
                      },
                      position: e.latLng.toJSON(),
                      title: featureName,
                      zIndex:
                        window.google.maps.Marker.MAX_ZINDEX +
                        Number(layers[l].id),
                      // optimized: false,
                    });
                    const link = layers[l]?.link
                      ? '<br /><a href="' +
                        layers[l].link +
                        '" target="_blank" class="gm-link">Learn More</a>'
                      : "";

                    layers[l].markers.window =
                      new window.google.maps.InfoWindow({
                        content: `<div class="gm-card">${retroFix(
                          featureName
                        )}${link}</div>`,
                        disableAutoPan: false,
                        zIndex:
                          window.google.maps.Marker.MAX_ZINDEX +
                          Number(layers[l].id),
                      });

                    layers[l].markers.window.open(
                      map,
                      layers[l].markers.marker
                    );

                    layers[l].markers.window.addListener("closeclick", () => {
                      layers[l].markers.marker.setMap(null);
                      delete layers[l].markers.marker;
                    });

                    layers[l].markers.marker.addListener("click", () => {
                      layers[l].markers.window.open({
                        anchor: layers[l].markers.marker,
                        map: map,
                        shouldFocus: false,
                      });
                    });
                  }
                });
              }

              layers[l].layer = geoLayer;
              if (layers[l].visible) {
                layers[l].layer.setMap(map);
              }
            })
            .catch((error) => console.log(error));
        }

        if (
          layers[l].type.includes("marker") ||
          layers[l].type.includes("label")
        ) {
          switch (layers[l].marker) {
            case "layerR":
              fetch(API, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  query: `
                        query MyQuery {
                          geomap {
                            geoLayers {
                              layerR {
                                number
                                name
                                lat
                                lng
                              }
                            }
                          }
                        }                
                      `,
                }),
              })
                .then((response) => response.json())
                .then((response) => {
                  const arrData = response.data.geomap.geoLayers.layerR;
                  const objData = Object.assign({}, arrData);

                  const markers = [];
                  for (const m in objData) {
                    if (
                      objData[m].hasOwnProperty("lat") &&
                      objData[m].hasOwnProperty("lng")
                    ) {
                      let path;
                      switch (String(objData[m]?.number)) {
                        case "1":
                          path =
                            "M16.36,35.55H8.11V9.28L0,11.65V5.4L15.6,0h.76Z";
                          break;
                        case "2":
                          path =
                            "M25.54,36.06H.73V30.69l11.43-12q4.22-4.81,4.22-7.64a5.33,5.33,0,0,0-1-3.5,3.58,3.58,0,0,0-2.9-1.19A3.63,3.63,0,0,0,9.42,8a6.55,6.55,0,0,0-1.17,4H0a11.56,11.56,0,0,1,1.64-6A11.43,11.43,0,0,1,6.18,1.56,13.48,13.48,0,0,1,12.67,0q5.76,0,8.88,2.66C23.62,4.44,24.66,7,24.66,10.3a11.09,11.09,0,0,1-.78,4.09,17.88,17.88,0,0,1-2.43,4.18,62.34,62.34,0,0,1-5.31,5.84l-4.59,5.3h14Z";
                          break;
                        case "3":
                          path =
                            "M8.54,14.84h3.89q4.61,0,4.61-4.51a3.92,3.92,0,0,0-1.1-2.87,4.15,4.15,0,0,0-3.1-1.11A4.46,4.46,0,0,0,10,7.3,2.88,2.88,0,0,0,8.79,9.67H.56a8.46,8.46,0,0,1,1.56-5A10.48,10.48,0,0,1,6.46,1.23,14.79,14.79,0,0,1,12.55,0q5.93,0,9.33,2.71a9,9,0,0,1,3.39,7.45,7.48,7.48,0,0,1-1.41,4.33,10,10,0,0,1-4.08,3.31,9.6,9.6,0,0,1,4.44,3.11,8.21,8.21,0,0,1,1.61,5.16,9.17,9.17,0,0,1-3.66,7.62q-3.66,2.87-9.62,2.86a15.85,15.85,0,0,1-6.48-1.33,10.13,10.13,0,0,1-4.53-3.69A9.56,9.56,0,0,1,0,26.17H8.28A3.71,3.71,0,0,0,9.59,29a4.67,4.67,0,0,0,3.25,1.2A4.86,4.86,0,0,0,16.31,29,4,4,0,0,0,17.6,25.9a4.74,4.74,0,0,0-1.34-3.81A5.66,5.66,0,0,0,12.55,21h-4Z";
                          break;
                        case "4":
                          path =
                            "M22.46,21.66h3.61V28H22.46v7.55H14.23V28H.49L0,23,14.23.07V0h8.23Zm-14.62,0h6.39V10.72l-.51.83Z";
                          break;
                        case "5":
                          path =
                            "M.68,18.18,2.86,0H23.63V6.4H9.55l-.81,7.06a9.49,9.49,0,0,1,2.31-.91,10.54,10.54,0,0,1,2.79-.39c3.53,0,6.25,1,8.15,3.14s2.84,5,2.84,8.8a12.59,12.59,0,0,1-1.53,6.19A10.51,10.51,0,0,1,19,34.55,13.56,13.56,0,0,1,12.5,36a14.51,14.51,0,0,1-6.27-1.38,11.19,11.19,0,0,1-4.59-3.78A9.18,9.18,0,0,1,0,25.45H8.25A4.64,4.64,0,0,0,9.5,28.54a3.92,3.92,0,0,0,2.95,1.15q4.16,0,4.15-6.14,0-5.68-5.08-5.68a5.06,5.06,0,0,0-4.29,1.85Z";
                          break;
                        case "6":
                          path =
                            "M20,0V6.47h-.37a12.39,12.39,0,0,0-7.58,2.21,9.33,9.33,0,0,0-3.65,6.14,9.64,9.64,0,0,1,7-2.74,9,9,0,0,1,7.35,3.37,13.58,13.58,0,0,1,2.74,8.84,12.54,12.54,0,0,1-1.6,6.23A11.47,11.47,0,0,1,19.47,35a12.89,12.89,0,0,1-6.36,1.6,13.32,13.32,0,0,1-6.76-1.72,11.86,11.86,0,0,1-4.64-4.92A16.13,16.13,0,0,1,0,22.53V19.24A20.55,20.55,0,0,1,2.36,9.36,17.08,17.08,0,0,1,9.08,2.49,19.26,19.26,0,0,1,18.77,0ZM12.6,18.38A4.64,4.64,0,0,0,8.23,21v2.46q0,6.74,4.66,6.74A3.8,3.8,0,0,0,16,28.52a6.87,6.87,0,0,0,1.26-4.23A6.71,6.71,0,0,0,16,20,4.09,4.09,0,0,0,12.6,18.38Z";
                          break;
                        case "7":
                          path =
                            "M25.61,4.39,12.33,35.55H3.64l13.3-29.2H0V0H25.61Z";
                          break;
                        case "8":
                          path =
                            "M24.1,10a8.18,8.18,0,0,1-1.29,4.57,9.41,9.41,0,0,1-3.52,3.17,10.34,10.34,0,0,1,4,3.4,8.84,8.84,0,0,1,1.48,5.12,9.3,9.3,0,0,1-3.28,7.52q-3.28,2.76-9,2.76c-3.86,0-6.91-.93-9.14-2.77A9.24,9.24,0,0,1,0,26.27a8.93,8.93,0,0,1,1.46-5.05,10,10,0,0,1,4.16-3.47,9.42,9.42,0,0,1-3.57-3.17A8.18,8.18,0,0,1,.76,10,9.11,9.11,0,0,1,3.91,2.69,12.66,12.66,0,0,1,12.4,0Q17.8,0,21,2.69A9.11,9.11,0,0,1,24.1,10Zm-7.55,15.6a4.73,4.73,0,0,0-1.13-3.38,4,4,0,0,0-3-1.19,4,4,0,0,0-3,1.19,4.69,4.69,0,0,0-1.14,3.38A4.67,4.67,0,0,0,9.44,29a4,4,0,0,0,3,1.23A3.83,3.83,0,0,0,15.43,29,4.78,4.78,0,0,0,16.55,25.61ZM12.4,6.35A3,3,0,0,0,9.88,7.43a4.72,4.72,0,0,0-.87,3,5,5,0,0,0,.88,3.08,3,3,0,0,0,2.59,1.17A2.9,2.9,0,0,0,15,13.53a5.2,5.2,0,0,0,.84-3.08,4.7,4.7,0,0,0-.86-3A3.07,3.07,0,0,0,12.4,6.35Z";
                          break;
                        case "9":
                          path =
                            "M16.46,22.31a8.69,8.69,0,0,1-6,2.4,9.64,9.64,0,0,1-7.67-3.27A12.9,12.9,0,0,1,0,12.7,13.09,13.09,0,0,1,1.59,6.35,11.82,11.82,0,0,1,6,1.71,12.18,12.18,0,0,1,12.38,0a11.81,11.81,0,0,1,6.36,1.77,12,12,0,0,1,4.43,5,17.16,17.16,0,0,1,1.63,7.46v3.15a21.34,21.34,0,0,1-2.3,10.21,16,16,0,0,1-6.58,6.64A20.52,20.52,0,0,1,6,36.55H5.44V30l1.57,0Q15.5,29.53,16.46,22.31Zm-3.74-3.54a4,4,0,0,0,3.86-2.31V13A8.94,8.94,0,0,0,15.43,8a3.6,3.6,0,0,0-3.1-1.63A3.42,3.42,0,0,0,9.42,8.2a8.28,8.28,0,0,0-1.17,4.5,7.38,7.38,0,0,0,1.2,4.43A3.82,3.82,0,0,0,12.72,18.77Z";
                          break;
                        case "0":
                          path =
                            "M24.78,21.51q0,7.2-3.23,11.11t-9.12,3.9q-5.94,0-9.18-3.93T0,21.51V15q0-7.2,3.24-11.1T12.38,0q5.91,0,9.15,3.93T24.78,15ZM16.55,14a12.63,12.63,0,0,0-1-5.72,3.34,3.34,0,0,0-3.17-1.89A3.25,3.25,0,0,0,9.29,8.11a12,12,0,0,0-1,5.32v9.08a12.74,12.74,0,0,0,1,5.82,3.37,3.37,0,0,0,3.18,1.85,3.31,3.31,0,0,0,3.1-1.8,12.2,12.2,0,0,0,1-5.63Z";
                          break;
                        default:
                          path =
                            "M24.62,48.75A24.13,24.13,0,1,1,48.75,24.62,24.15,24.15,0,0,1,24.62,48.75Z";
                          break;
                      }

                      if (
                        layers[l].type.includes("marker") &&
                        layers[l].type.includes("label")
                      ) {
                        objData[m].marker = new window.google.maps.Marker({
                          map: map,
                          position: new window.google.maps.LatLng(
                            parseFloat(objData[m]?.lat),
                            parseFloat(objData[m]?.lng)
                          ),
                          title: cleanString(objData[m]?.name),
                          label: {
                            text: cleanString(objData[m]?.name),
                            className: "gm-label-main",
                            color: layers[l].color,
                            fontSize: "16px",
                          },
                          icon: {
                            path: path,
                            scale: 0.6,
                            fillColor: layers[l].color,
                            fillOpacity: 0.4,
                            strokeColor: layers[l].color,
                            strokeOpacity: 0.3,
                            strokeWeight: layers[l].width,
                            labelOrigin: new window.google.maps.Point(0, 50),
                          },
                          zIndex:
                            window.google.maps.Marker.MAX_ZINDEX +
                            Number(layers[l].id) +
                            1,
                          // optimized: false,
                        });
                      } else if (layers[l].type.includes("label")) {
                        objData[m].marker = new window.google.maps.Marker({
                          map: map,
                          position: new window.google.maps.LatLng(
                            parseFloat(objData[m]?.lat),
                            parseFloat(objData[m]?.lng)
                          ),
                          anchorPoint: new window.google.maps.Point(0, 5),
                          label: {
                            text: cleanString(objData[m]?.name),
                            className: "gm-label-main",
                            color: layers[l].color,
                            fontSize: "16px",
                          },
                          zIndex:
                            window.google.maps.Marker.MAX_ZINDEX +
                            Number(layers[l].id) +
                            1,
                          // optimized: false,
                        });
                      } else {
                        objData[m].marker = new window.google.maps.Marker({
                          map: map,
                          position: new window.google.maps.LatLng(
                            parseFloat(objData[m]?.lat),
                            parseFloat(objData[m]?.lng)
                          ),
                          title: cleanString(objData[m]?.name),
                          icon: {
                            path: path,
                            scale: 0.6,
                            fillColor: layers[l].color,
                            fillOpacity: 0.6,
                            strokeColor: layers[l].color,
                            strokeOpacity: 0.5,
                            strokeWeight: layers[l].width,
                            labelOrigin: new window.google.maps.Point(0, 50),
                          },
                          zIndex:
                            window.google.maps.Marker.MAX_ZINDEX +
                            Number(layers[l].id) +
                            1,
                          // optimized: false,
                        });
                      }

                      objData[m].marker.addListener("click", (e) => {
                        const latLng = e.latLng;
                        map.panTo(latLng);
                        map.setZoom(8);
                      });

                      markers.push(objData[m].marker);
                    }
                  }

                  layers[l].data = objData;
                })
                .catch((error) => {
                  console.error(error);
                });
              break;
            case "layerO":
              fetch(API, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  query: `
                        query MyQuery {
                          geomap {
                            geoLayers {
                              layerO {
                                description
                                fax
                                lat
                                lng
                                number
                                name
                                phone
                              }
                            }
                          }
                        }                
                      `,
                }),
              })
                .then((response) => response.json())
                .then((response) => {
                  const arrData = response.data.geomap.geoLayers.layerO;
                  const objData = Object.assign({}, arrData);

                  // const svg = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 19.8 19.8" enableBackground="new 0 0 19.8 19.8">
                  // <g>
                  //   <path fill="${layers[l].color}" d="M17.3,19.2c-1.8,0-3.5,0-5.3,0c0-1.9,0-3.8,0-5.7c0-1.2-0.9-2.2-2-2.2c-1.1,0-2,0.9-2,2.2c0,1.2,0,2.3,0,3.5
                  //     c0,0.7,0,1.4,0,2.2c-1.8,0-3.6,0-5.4,0c0-2.5,0-5,0-7.5c0-0.3,0.1-0.5,0.3-0.7C4.5,9.2,6.2,7.5,8,5.7c0.7-0.7,1.3-1.4,2-2.1
                  //     c0.1,0.1,0.2,0.1,0.2,0.2c2.3,2.4,4.6,4.8,7,7.3c0.1,0.1,0.2,0.3,0.2,0.5c0,2.4,0,4.9,0,7.3C17.3,19,17.3,19.1,17.3,19.2z"/>
                  //   <path fill="${layers[l].color}" d="M19.5,10.2c0,0.1,0,0.2,0,0.3c-0.2,0.4-0.5,0.8-0.9,1c-0.2,0.1-0.4,0.1-0.6-0.1c-2.2-2.4-4.5-4.7-6.8-7
                  //     C10.9,3.9,10.4,3.5,9.9,3c0,0-0.1,0.1-0.2,0.2c-2.6,2.7-5.1,5.3-7.7,8c-0.4,0.4-0.6,0.5-1,0c-0.2-0.2-0.3-0.4-0.5-0.6
                  //     c0-0.1-0.1-0.1-0.1-0.1c0-0.1,0-0.2,0-0.3c0.1-0.1,0.2-0.1,0.2-0.2C2.5,8,4.4,6,6.4,4c1.1-1.1,2.2-2.2,3.3-3.3c0.1,0,0.3,0,0.4,0
                  //     c0.2,0.2,0.4,0.3,0.6,0.5c1.4,1.5,2.9,3,4.3,4.5C16.6,7.2,18.1,8.7,19.5,10.2z"/>
                  // </g>
                  // </svg>`;

                  const svgLabel = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  viewBox="0 0 95.3 39.7" enableBackground="new 0 0 95.3 39.7">
               <rect x="0.5" y="22.9" fill="none" stroke="none" stroke-miterlimit="10" width="94.3" height="16.2"/>
               <g>
                 <path fill="${layers[l].color}" d="M55.3,19.2c-1.8,0-3.5,0-5.3,0c0-1.9,0-3.8,0-5.7c0-1.2-0.9-2.2-2-2.2c-1.1,0-2,0.9-2,2.2c0,1.2,0,2.3,0,3.5
                   c0,0.7,0,1.4,0,2.2c-1.8,0-3.6,0-5.4,0c0-2.5,0-5,0-7.5c0-0.3,0.1-0.5,0.3-0.7c1.6-1.8,3.3-3.5,5.1-5.3c0.7-0.7,1.3-1.4,2-2.1
                   c0.1,0.1,0.2,0.1,0.2,0.2c2.3,2.4,4.6,4.8,7,7.3c0.1,0.1,0.2,0.3,0.2,0.5c0,2.4,0,4.9,0,7.3C55.3,19,55.3,19.1,55.3,19.2z"/>
                 <path fill="${layers[l].color}" d="M57.5,10.2c0,0.1,0,0.2,0,0.3c-0.2,0.4-0.5,0.8-0.9,1c-0.2,0.1-0.4,0.1-0.6-0.1c-2.2-2.4-4.5-4.7-6.8-7
                   c-0.3-0.5-0.8-0.9-1.3-1.4c0,0-0.1,0.1-0.2,0.2c-2.6,2.7-5.1,5.3-7.7,8c-0.4,0.4-0.6,0.5-1,0c-0.2-0.2-0.3-0.4-0.5-0.6
                   c0-0.1-0.1-0.1-0.1-0.1c0-0.1,0-0.2,0-0.3c0.1-0.1,0.2-0.1,0.2-0.2c1.9-2,3.8-4,5.8-6c1.1-1.1,2.2-2.2,3.3-3.3c0.1,0,0.3,0,0.4,0
                   c0.2,0.2,0.4,0.3,0.6,0.5c1.4,1.5,2.9,3,4.3,4.5C54.6,7.2,56.1,8.7,57.5,10.2z"/>
               </g>
               </svg>`;

                  for (const m in objData) {
                    if (
                      objData[m].hasOwnProperty("lat") &&
                      objData[m].hasOwnProperty("lng")
                    ) {
                      if (
                        layers[l].type.includes("marker") &&
                        layers[l].type.includes("label")
                      ) {
                        objData[m].marker = new window.google.maps.Marker({
                          // map: map,
                          position: new window.google.maps.LatLng(
                            parseFloat(objData[m]?.lat),
                            parseFloat(objData[m]?.lng)
                          ),
                          anchorPoint: new window.google.maps.Point(0, -45),
                          title: cleanString(objData[m]?.name),
                          label: {
                            text: cleanString(objData[m]?.name),
                            className: "gm-label",
                            color: layers[l].color,
                            fontSize: layers[l].size,
                          },
                          icon: {
                            url: `data:image/svg+xml;base64,${window.btoa(
                              svgLabel
                            )}`,
                            scaledSize: new window.google.maps.Size(
                              svgLabelSizeW,
                              svgLabelSizeH
                            ),
                          },
                          zIndex:
                            window.google.maps.Marker.MAX_ZINDEX +
                            Number(layers[l].id),
                          // optimized: false,
                        });
                      } else if (layers[l].type.includes("label")) {
                        objData[m].marker = new window.google.maps.Marker({
                          // map: map,
                          position: new window.google.maps.LatLng(
                            parseFloat(objData[m]?.lat),
                            parseFloat(objData[m]?.lng)
                          ),
                          anchorPoint: new window.google.maps.Point(0, 5),
                          label: {
                            text: cleanString(objData[m]?.name),
                            className: "gm-label",
                            color: layers[l].color,
                            fontSize: layers[l].size,
                          },
                          icon: {
                            anchor: new window.google.maps.Point(50, 20),
                            url: svgTransparent,
                            scaledSize: new window.google.maps.Size(
                              svgLabelSizeW,
                              svgLabelSizeH
                            ),
                          },
                          zIndex:
                            window.google.maps.Marker.MAX_ZINDEX +
                            Number(layers[l].id),
                          // optimized: false,
                        });
                      } else {
                        objData[m].marker = new window.google.maps.Marker({
                          // map: map,
                          position: new window.google.maps.LatLng(
                            parseFloat(objData[m]?.lat),
                            parseFloat(objData[m]?.lng)
                          ),
                          anchorPoint: new window.google.maps.Point(0, -45),
                          title: cleanString(objData[m]?.name),
                          icon: {
                            url: `data:image/svg+xml;base64,${window.btoa(
                              svgLabel
                            )}`,
                            scaledSize: new window.google.maps.Size(
                              svgLabelSizeW,
                              svgLabelSizeH
                            ),
                          },
                          zIndex:
                            window.google.maps.Marker.MAX_ZINDEX +
                            Number(layers[l].id),
                          // optimized: false,
                        });
                      }

                      const content = `<div class="gm-card gm-card-address">
                      <span hidden>${
                        objData[m]?.number ? objData[m]?.number : ""
                      }</span>
                      <div class="title color-primary">${objData[m]?.name}</div>
                      <div class="subtitle">CLC office</div>
                      ${
                        objData[m]?.phone
                          ? "Tel: " + objData[m].phone + "<br />"
                          : ""
                      }
                      ${
                        objData[m]?.fax
                          ? "Fax: " + objData[m].fax + "<br />"
                          : ""
                      }
                      ${objData[m]?.description ? objData[m].description : ""}
                      </div>`;

                      if (layers[l].visible) {
                        objData[m].marker.setMap(map);
                      }

                      objData[m].window = new window.google.maps.InfoWindow({
                        content: content,
                        disableAutoPan: false,
                        zIndex:
                          window.google.maps.Marker.MAX_ZINDEX +
                          Number(layers[l].id),
                        maxWidth: 200,
                      });

                      objData[m].marker.addListener("click", () => {
                        closeWindowHandler(layers, l);
                        objData[m].window.open({
                          anchor: objData[m].marker,
                          map: map,
                          shouldFocus: false,
                        });
                      });
                    }
                  }

                  layers[l].data = objData;
                })
                .catch((error) => {
                  console.error(error);
                });
              break;
            case "layerM":
              fetch(API, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  query: `
                        query MyQuery {
                          geomap {
                            geoLayers {
                              layerM {
                                lat
                                link
                                lng
                                location
                                name
                                image {
                                  mediaItemUrl
                                }
                                region
                                represented
                                label
                              }
                            }
                          }
                        }                
                      `,
                }),
              })
                .then((response) => response.json())
                .then((response) => {
                  const arrData = response.data.geomap.geoLayers.layerM;
                  // const objData = Object.assign({}, arrData);
                  let objData = [...arrData];

                  //                 const svg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 12 15.7">
                  //                 <path fill="${layers[l].color}" d="M7.3,9.6C8,9.4,8.7,9,9.3,8.4c0.7-0.8,1.3-1.9,1.3-3.2
                  // S10,2.9,9.2,2.1S7.3,0.7,6,0.7S3.6,1.3,2.8,2.1S1.5,4,1.5,5.3S2,7.6,2.8,8.4C3.4,9,4,9.3,4.8,9.6c-2.7,0.4-4.3,1.9-4.3,3.5
                  // c0,0.9,2,1.8,5.4,1.8c3.2,0,5.4-0.9,5.4-1.8C11.4,11.6,9.8,10,7.3,9.6z"/>
                  //               </svg>`;

                  const svgLabel = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 95.3 39.7" enableBackground="new 0 0 95.3 39.7">
                <g>
                  <rect x="0.5" y="22.9" fill="none" stroke="none" stroke-miterlimit="10" width="94.3" height="16.2"/>
                  <path fill="${layers[l].color}" d="M49.3,12c0.8-0.2,1.7-0.7,2.4-1.5c0.8-1,1.6-2.3,1.6-3.9s-0.7-2.8-1.7-3.8
                    s-2.3-1.7-3.9-1.7s-2.9,0.7-3.9,1.7s-1.6,2.3-1.6,3.9s0.6,2.8,1.6,3.8c0.7,0.7,1.5,1.1,2.4,1.5c-3.3,0.5-5.2,2.3-5.2,4.2
                    c0,1.1,2.4,2.2,6.5,2.2c3.9,0,6.5-1.1,6.5-2.2C54.3,14.4,52.4,12.5,49.3,12z"/>
                </g>
                </svg>`;

                  // const markers = [];
                  for (const m in objData) {
                    if (
                      objData[m].hasOwnProperty("lat") &&
                      objData[m].hasOwnProperty("lng")
                    ) {
                      if (!objData[m].label) {
                        objData[m].marker = null;
                      } else if (
                        layers[l].type.includes("marker") &&
                        layers[l].type.includes("label")
                      ) {
                        objData[m].marker = new window.google.maps.Marker({
                          // map: map,
                          position: new window.google.maps.LatLng(
                            parseFloat(objData[m]?.lat),
                            parseFloat(objData[m]?.lng)
                          ),
                          title: cleanString(objData[m]?.location),
                          label: {
                            text: objData[m]?.location.replace(
                              /<\/?[^>]+(>|$)/g,
                              ""
                            ),
                            // className: "gm-label label-max",
                            className: "gm-label",
                            color: layers[l].color,
                            fontSize: layers[l].size,
                          },
                          icon: {
                            anchor: new window.google.maps.Point(50, 20),
                            url: `data:image/svg+xml;base64,${window.btoa(
                              svgLabel
                            )}`,
                            scaledSize: new window.google.maps.Size(
                              svgLabelSizeW,
                              svgLabelSizeH
                            ),
                          },
                          zIndex:
                            window.google.maps.Marker.MAX_ZINDEX +
                            Number(layers[l].id),
                          // optimized: false,
                        });
                      } else if (layers[l].type.includes("label")) {
                        objData[m].marker = new window.google.maps.Marker({
                          // map: map,
                          position: new window.google.maps.LatLng(
                            parseFloat(objData[m]?.lat),
                            parseFloat(objData[m]?.lng)
                          ),
                          label: {
                            text: objData[m]?.location.replace(
                              /<\/?[^>]+(>|$)/g,
                              ""
                            ),
                            // className: "gm-label label-max",
                            className: "gm-label",
                            color: layers[l].color,
                            fontSize: layers[l].size,
                          },
                          icon: {
                            anchor: new window.google.maps.Point(50, 20),
                            url: svgTransparent,
                            scaledSize: new window.google.maps.Size(
                              svgLabelSizeW,
                              svgLabelSizeH
                            ),
                          },
                          zIndex:
                            window.google.maps.Marker.MAX_ZINDEX +
                            Number(layers[l].id),
                          // optimized: false,
                        });
                      } else {
                        objData[m].marker = new window.google.maps.Marker({
                          // map: map,
                          position: new window.google.maps.LatLng(
                            parseFloat(objData[m]?.lat),
                            parseFloat(objData[m]?.lng)
                          ),
                          title: cleanString(objData[m]?.location),
                          icon: {
                            anchor: new window.google.maps.Point(50, 20),
                            url: `data:image/svg+xml;base64,${window.btoa(
                              svgLabel
                            )}`,
                            scaledSize: new window.google.maps.Size(
                              svgLabelSizeW,
                              svgLabelSizeH
                            ),
                          },
                          zIndex:
                            window.google.maps.Marker.MAX_ZINDEX +
                            Number(layers[l].id),
                          // optimized: false,
                        });
                      }

                      if (layers[l].visible) {
                        objData[m]?.marker && objData[m].marker.setMap(map);
                      }

                      objData[m]?.marker &&
                        objData[m].marker.addListener("click", (e) => {
                          closeWindowHandler(layers, l);
                          const p1 = e.latLng.toJSON();
                          const objArr = [];
                          objData.forEach((m) => {
                            const p2 = {
                              lat: parseFloat(m.lat),
                              lng: parseFloat(m.lng),
                            };
                            getDistanceByKm(p1, p2) <= 5 && objArr.push(m);
                          });

                          const clusterContent = [
                            '<div class="grow" data-col="' +
                              objArr.length +
                              '">',
                          ];
                          objArr.forEach((o) => {
                            const image = o?.image?.mediaItemUrl
                              ? `<figure><img src="${o.image.mediaItemUrl}" /></figure>`
                              : "<figure></figure>";
                            const link = o?.link
                              ? `<a href="${o.link}#${o?.name.replace(
                                  /[^A-Z0-9]/gi,
                                  "-"
                                )}" target="_blank" class="gm-link">Learn More</a>`
                              : "";
                            clusterContent.push(`<div class="gcol gcol-2"><div class="gm-card gm-card-member">
                            ${image}
                            <div class="title color-primary">${
                              o?.name
                            }</div><br />
                            ${o?.represented ? o.represented + "<br />" : ""}
                            ${link}
                          </div></div>`);
                          });

                          clusterContent.push("</div>");

                          layers[l].windows = new window.google.maps.InfoWindow(
                            {
                              content: clusterContent.join(""),
                              position: e.latLng,
                              pixelOffset: new window.google.maps.Size(
                                -2.5,
                                -20
                              ),
                              disableAutoPan: false,
                              zIndex:
                                window.google.maps.Marker.MAX_ZINDEX +
                                Number(layers[l].id),
                            }
                          );

                          layers[l].windows.open({ map, shouldFocus: false });
                        });
                    }
                  }

                  layers[l].data = objData;
                })
                .catch((error) => {
                  console.error(error);
                });

              break;
            case "layerRg":
              fetch(API, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  query: `
                        query MyQuery {
                          geomap {
                            geoLayers {
                              layerRg {
                                gid
                                lat
                                link
                                lng
                                location
                                name
                                logo {
                                  mediaItemUrl
                                }
                              }
                            }
                          }
                        }                
                      `,
                }),
              })
                .then((response) => response.json())
                .then((response) => {
                  const arrData = response.data.geomap.geoLayers.layerRg;
                  const objData = Object.assign({}, arrData);

                  // const svg = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 19.8 19.8" enableBackground="new 0 0 19.8 19.8">
                  // <path fill="${layers[l].color}" d="M1.2,15.9c0.2-0.1,0.2-0.4,0.4-0.6c0.4-0.5,1-0.8,1.5-1.1c0.2-0.1,0.3-0.2,0.5-0.2c0.3-0.2,0.5-0.5,0.5-0.9
                  //   C4,12,4.4,10.9,5.1,9.9C5.6,9.2,6.2,8.6,6.8,8c0.8-0.8,1.8-1.2,3-1.2c0.5,0,0.9,0,1.4-0.1c0.3-0.1,0.4-0.2,0.5-0.4
                  //   c0.1-0.1,0-0.2,0-0.3c-0.2-0.2-0.4-0.4-0.6-0.6c-0.5-0.4-0.9-0.7-1.3-1.2C9.4,3.9,9.2,3.4,9.1,2.8c0-0.5,0-1,0-1.6
                  //   C9.2,1,9.3,0.9,9.6,1c0.4,0.2,0.8,0.4,1.1,0.6C10.9,1.8,11,2,11.1,2.1c0.4,0.8,0.8,1.6,1.2,2.4c0.1,0.2,0.2,0.5,0.4,0.7
                  //   c0.1,0.2,0.3,0.3,0.5,0.1c0,0,0,0,0.1,0c0.4,0,0.4-0.3,0.4-0.6c0-0.3,0.1-0.6,0.2-0.8c0.2-0.4,0.4-0.9,0.5-1.3
                  //   c0-0.1,0.1-0.3,0.2-0.4c0.4-0.4,0.6-0.9,0.7-1.5c0-0.1,0-0.3,0.2-0.3c0.2,0,0.2,0.2,0.3,0.3c0.1,0.5,0.1,0.9,0,1.4
                  //   c-0.2,1.1-0.5,2.2-0.9,3.2c-0.1,0.2-0.1,0.3,0.2,0.4c0.3,0,0.6,0.1,0.8,0.3c0.2,0.1,0.3,0.3,0.6,0.3c0.2,0,0.3,0.2,0.4,0.4
                  //   C17,6.9,17.2,7,17.4,7.1c0.6,0.1,0.9,0.5,1.2,0.8c0,0,0,0.1,0,0.1c-0.2,0.1-0.4,0.1-0.6,0.1c-0.8,0.1-1.6,0.4-2.3,0.9
                  //   c-0.3,0.2-0.5,0.5-0.9,0.6c-0.5,0.1-0.8,0.5-1.1,0.8c0,0.1-0.1,0.1-0.1,0.2c-0.4,0.4-0.5,0.9-0.3,1.3c0.1,0.5,0,1,0,1.4
                  //   c0,0.2,0,0.4,0,0.7c0,0.4,0,0.4,0.4,0.4c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.3,0.2c0.1,0.2-0.1,0.1-0.1,0.2c0,0,0,0.1,0,0.1
                  //   c0.1,0.2,0,0.2-0.2,0.1c-0.2-0.1-0.3-0.1-0.5,0c-0.1,0-0.3,0.1-0.3,0.2c0,0.2-0.1,0.2-0.3,0.1c-0.1,0-0.3-0.2-0.3,0.1
                  //   c0,0.1-0.1,0-0.1,0c-0.2-0.2-0.5-0.2-0.8-0.3c-0.2,0-0.3-0.1-0.3-0.3c-0.1-0.2-0.2-0.5-0.3-0.7c-0.2-0.3-0.4-0.5-0.6-0.7
                  //   c-0.1-0.1-0.2-0.3-0.3-0.4c0-0.3-0.2-0.2-0.3-0.1c-0.3,0.2-0.4,0.5-0.6,0.7c0,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.1,0.2,0.1
                  //   c0.3,0,0.5,0,0.8,0c0.3,0,0.6,0.1,0.7,0.4c-0.1,0-0.2,0.1-0.3,0.2c-0.2-0.1-0.1,0.2-0.2,0.3c-0.1-0.1-0.3-0.1-0.4-0.2
                  //   c-0.2-0.2-0.4-0.2-0.7-0.2c-0.3,0.1-0.5,0.1-0.8,0c-0.2-0.1-0.4,0-0.6,0.1c-0.2,0.1-0.2,0.2,0,0.3C8,14.7,8.2,14.9,8.3,15
                  //   c0.1,0.1,0,0.3-0.1,0.3c-0.2,0.1-0.4,0.2-0.6,0c-0.2-0.1-0.5-0.2-0.8-0.2c-0.4-0.1-0.9,0-1.3-0.1c-0.2,0-0.4-0.1-0.4-0.3
                  //   c0-0.2-0.2-0.2-0.3-0.2c-0.6,0-1.1,0-1.6,0.2c-0.5,0.2-1,0.5-1.3,1c-0.5,0.8-0.1,1.7,0.8,1.9C3,17.9,3.3,17.9,3.7,18
                  //   c1.2,0.2,2.4,0.1,3.6,0.3c0.3,0.1,0.7,0.1,0.9,0.4c0.1,0.1,0.2,0.2,0.1,0.2c-0.2,0-0.4,0.2-0.6,0.2c-0.5,0-1,0.2-1.5,0.1
                  //   c0,0,0,0,0,0C5.9,19.1,6,19.3,6,19.5c-0.4-0.2-0.9-0.2-1.3-0.3c-0.1,0-0.2-0.1-0.2,0c-0.1,0.1-0.2,0.1-0.3,0c-0.7-0.3-1.3-0.6-1.9-1
                  //   c-0.4-0.3-0.8-0.7-0.9-1.2c0-0.1,0-0.1-0.1-0.1C1.2,16.6,1.2,16.2,1.2,15.9z M12.5,14.3c0-0.1,0-0.3,0-0.4c0-0.5-0.3-0.9-0.3-1.5
                  //   c0-0.1,0-0.3-0.1-0.3c-0.1,0-0.3,0.1-0.4,0.2c0,0.1,0,0.3,0,0.4c0.2,0.4,0.2,0.8,0.3,1.1c0,0.1,0.1,0.3,0.1,0.4
                  //   c0.1,0.2,0.2,0.3,0.3,0.2C12.6,14.6,12.5,14.4,12.5,14.3z"/>
                  // </svg>`;

                  const svgLabel = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  viewBox="0 0 95.3 40.1" enableBackground="new 0 0 95.3 40.1">
               <path fill="${layers[l].color}" d="M37.6,18.5c0.2-0.1,0.2-0.5,0.5-0.7c0.5-0.6,1.2-0.9,1.7-1.3c0.2-0.1,0.3-0.2,0.6-0.2c0.3-0.2,0.6-0.6,0.6-1
                 c-0.1-1.3,0.3-2.6,1.2-3.7c0.6-0.8,1.3-1.5,2-2.2C45,8.4,46.1,8,47.5,8c0.6,0,1,0,1.6-0.1c0.3-0.1,0.5-0.2,0.6-0.5
                 c0.1-0.1,0-0.2,0-0.3c-0.2-0.2-0.5-0.5-0.7-0.7c-0.6-0.5-1-0.8-1.5-1.4c-0.5-0.3-0.7-0.9-0.8-1.6c0-0.6,0-1.2,0-1.9
                 c0.1-0.2,0.2-0.3,0.6-0.2c0.5,0.2,0.9,0.5,1.3,0.7c0.2,0.2,0.3,0.5,0.5,0.6c0.5,0.9,0.9,1.9,1.4,2.8c0.1,0.2,0.2,0.6,0.5,0.8
                 c0.1,0.2,0.3,0.3,0.6,0.1c0,0,0,0,0.1,0c0.5,0,0.5-0.3,0.5-0.7c0-0.3,0.1-0.7,0.2-0.9c0.2-0.5,0.5-1,0.6-1.5c0-0.1,0.1-0.3,0.2-0.5
                 c0.5-0.5,0.7-1,0.8-1.7c0-0.1,0-0.3,0.2-0.3s0.2,0.2,0.3,0.3c0.1,0.6,0.1,1,0,1.6c-0.2,1.3-0.6,2.6-1,3.7c-0.1,0.2-0.1,0.3,0.2,0.5
                 c0.3,0,0.7,0.1,0.9,0.3c0.2,0.1,0.3,0.3,0.7,0.3c0.2,0,0.3,0.2,0.5,0.5c0.1,0.2,0.3,0.3,0.6,0.5c0.7,0.1,1,0.6,1.4,0.9v0.1
                 c-0.2,0.1-0.5,0.1-0.7,0.1c-0.9,0.1-1.9,0.5-2.7,1c-0.3,0.2-0.6,0.6-1,0.7c-0.6,0.1-0.9,0.6-1.3,0.9c0,0.1-0.1,0.1-0.1,0.2
                 c-0.5,0.5-0.6,1-0.3,1.5c0.1,0.6,0,1.2,0,1.6c0,0.2,0,0.5,0,0.8c0,0.5,0,0.5,0.5,0.5c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.3,0.2
                 c0.1,0.2-0.1,0.1-0.1,0.2v0.1c0.1,0.2,0,0.2-0.2,0.1c-0.2-0.1-0.3-0.1-0.6,0c-0.1,0-0.3,0.1-0.3,0.2c0,0.2-0.1,0.2-0.3,0.1
                 c-0.1,0-0.3-0.2-0.3,0.1c0,0.1-0.1,0-0.1,0c-0.2-0.2-0.6-0.2-0.9-0.3c-0.2,0-0.3-0.1-0.3-0.3c-0.1-0.2-0.2-0.6-0.3-0.8
                 c-0.2-0.3-0.5-0.6-0.7-0.8c-0.1-0.1-0.2-0.3-0.3-0.5c0-0.3-0.2-0.2-0.3-0.1c-0.3,0.2-0.5,0.6-0.7,0.8c0,0-0.1,0.1-0.1,0.2
                 c0,0.1,0.1,0.1,0.2,0.1c0.3,0,0.6,0,0.9,0c0.3,0,0.7,0.1,0.8,0.5c-0.1,0-0.2,0.1-0.3,0.2c-0.2-0.1-0.1,0.2-0.2,0.3
                 c-0.1-0.1-0.3-0.1-0.5-0.2c-0.2-0.2-0.5-0.2-0.8-0.2c-0.3,0.1-0.6,0.1-0.9,0c-0.2-0.1-0.5,0-0.7,0.1c-0.2,0.1-0.2,0.2,0,0.3
                 c0.1-0.1,0.3,0.1,0.5,0.2c0.1,0.1,0,0.3-0.1,0.3c-0.2,0.1-0.5,0.2-0.7,0c-0.2-0.1-0.6-0.2-0.9-0.2c-0.5-0.1-1,0-1.5-0.1
                 c-0.2,0-0.5-0.1-0.5-0.3c0-0.2-0.2-0.2-0.3-0.2c-0.7,0-1.3,0-1.9,0.2c-0.6,0.2-1.2,0.6-1.5,1.2c-0.6,0.9-0.1,2,0.9,2.2
                 c0.3,0.3,0.7,0.3,1.2,0.5c1.4,0.2,2.8,0.1,4.2,0.3c0.3,0.1,0.8,0.1,1,0.5c0.1,0.1,0.2,0.2,0.1,0.2c-0.2,0-0.5,0.2-0.7,0.2
                 c-0.6,0-1.2,0.2-1.7,0.1l0,0c-0.3-0.1-0.2,0.1-0.2,0.3c-0.5-0.2-1-0.2-1.5-0.3c-0.1,0-0.2-0.1-0.2,0c-0.1,0.1-0.2,0.1-0.3,0
                 c-0.8-0.3-1.5-0.7-2.2-1.2c-0.5-0.3-0.9-0.8-1-1.4c0-0.1,0-0.1-0.1-0.1C37.6,19.4,37.6,18.9,37.6,18.5z M50.7,16.7
                 c0-0.1,0-0.3,0-0.5c0-0.6-0.3-1-0.3-1.7c0-0.1,0-0.3-0.1-0.3s-0.3,0.1-0.5,0.2c0,0.1,0,0.3,0,0.5c0.2,0.5,0.2,0.9,0.3,1.3
                 c0,0.1,0.1,0.3,0.1,0.5c0.1,0.2,0.2,0.3,0.3,0.2C50.8,17,50.7,16.8,50.7,16.7z"/>
               <rect x="0.5" y="23.4" fill="none" stroke="none" stroke-miterlimit="10" width="94.3" height="16.2"/>
               </svg>`;

                  for (const m in objData) {
                    if (
                      objData[m].hasOwnProperty("lat") &&
                      objData[m].hasOwnProperty("lng")
                    ) {
                      if (
                        layers[l].type.includes("marker") &&
                        layers[l].type.includes("label")
                      ) {
                        objData[m].marker = new window.google.maps.Marker({
                          // map: map,
                          position: new window.google.maps.LatLng(
                            parseFloat(objData[m]?.lat),
                            parseFloat(objData[m]?.lng)
                          ),
                          anchorPoint: new window.google.maps.Point(0, -20),
                          title: cleanString(objData[m]?.name),
                          label: {
                            text: cleanString(objData[m]?.name),
                            className: "gm-label",
                            color: layers[l].color,
                            fontSize: layers[l].size,
                          },
                          icon: {
                            anchor: new window.google.maps.Point(50, 20),
                            url: `data:image/svg+xml;base64,${window.btoa(
                              svgLabel
                            )}`,
                            scaledSize: new window.google.maps.Size(
                              svgLabelSizeW,
                              svgLabelSizeH
                            ),
                          },
                          zIndex:
                            window.google.maps.Marker.MAX_ZINDEX +
                            Number(layers[l].id),
                          // optimized: false,
                        });
                      } else if (layers[l].type.includes("label")) {
                        objData[m].marker = new window.google.maps.Marker({
                          // map: map,
                          position: new window.google.maps.LatLng(
                            parseFloat(objData[m]?.lat),
                            parseFloat(objData[m]?.lng)
                          ),
                          anchorPoint: new window.google.maps.Point(0, 5),
                          label: {
                            text: cleanString(objData[m]?.name),
                            className: "gm-label",
                            color: layers[l].color,
                            fontSize: layers[l].size,
                          },
                          icon: {
                            anchor: new window.google.maps.Point(50, 20),
                            url: svgTransparent,
                            scaledSize: new window.google.maps.Size(
                              svgLabelSizeW,
                              svgLabelSizeH
                            ),
                          },
                          zIndex:
                            window.google.maps.Marker.MAX_ZINDEX +
                            Number(layers[l].id),
                          // optimized: false,
                        });
                      } else {
                        objData[m].marker = new window.google.maps.Marker({
                          // map: map,
                          position: new window.google.maps.LatLng(
                            parseFloat(objData[m]?.lat),
                            parseFloat(objData[m]?.lng)
                          ),
                          title: cleanString(objData[m]?.name),
                          icon: {
                            url: `data:image/svg+xml;base64,${window.btoa(
                              svgLabel
                            )}`,
                            scaledSize: new window.google.maps.Size(
                              svgLabelSizeW,
                              svgLabelSizeH
                            ),
                          },
                          zIndex:
                            window.google.maps.Marker.MAX_ZINDEX +
                            Number(layers[l].id),
                          // optimized: false,
                        });
                      }

                      const image = objData[m]?.logo?.mediaItemUrl
                        ? `<figure><img src="${objData[m].logo.mediaItemUrl}" /></figure>`
                        : "<figure></figure>";
                      const link = objData[m]?.link
                        ? `<a href="${objData[m].link}" target="_blank" class="gm-link">Learn More</a>`
                        : "";

                      const content = `<div class="gm-card gm-card-office">
                      ${image}
                      <div class="title color-primary">${
                        objData[m]?.name
                      }</div><br />
                      ${
                        objData[m].location
                          ? objData[m].location + "<br />"
                          : ""
                      }
                      ${link}
                      </div>`;

                      if (layers[l].visible) {
                        objData[m].marker.setMap(map);
                      }

                      objData[m].window = new window.google.maps.InfoWindow({
                        content: content,
                        disableAutoPan: false,
                        zIndex:
                          window.google.maps.Marker.MAX_ZINDEX +
                          Number(layers[l].id),
                      });

                      objData[m].marker.addListener("click", () => {
                        closeWindowHandler(layers, l);
                        objData[m].window.open({
                          anchor: objData[m].marker,
                          map: map,
                          shouldFocus: false,
                        });
                      });
                    }
                  }

                  layers[l].data = objData;
                })
                .catch((error) => {
                  console.error(error);
                });

              break;
            case "layerCdp":
              fetch(API, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  query: `
                        query MyQuery {
                          geomap {
                            geoLayers {
                              layerCdp {
                                funding
                                link
                                lat
                                lng
                                location
                                name
                                note
                                label
                              }
                            }
                          }
                        }                
                      `,
                }),
              })
                .then((response) => response.json())
                .then((response) => {
                  const arrData = response.data.geomap.geoLayers.layerCdp;
                  const objData = Object.assign({}, arrData);

                  //     const svg = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 19.8 19.8" enableBackground="new 0 0 19.8 19.8">
                  //  <g>
                  //    <path fill="${layers[l].color}" d="M19.4,10c0,5.2-4.3,9.4-9.5,9.4c-5.2,0-9.5-4.2-9.5-9.4c0-5.2,4.2-9.5,9.4-9.5C15.2,0.5,19.4,4.7,19.4,10z M1.7,9.9
                  //      c0,4.5,3.7,8.3,8.2,8.3c4.6,0,8.3-3.7,8.3-8.2c0-4.6-3.7-8.3-8.3-8.3C5.4,1.6,1.7,5.4,1.7,9.9z"/>
                  //    <path fill="${layers[l].color}" d="M9.9,3.5c3.5,0,6.4,2.8,6.4,6.4c0,3.5-2.9,6.3-6.3,6.3c-3.5,0-6.4-2.8-6.4-6.3C3.6,6.4,6.4,3.5,9.9,3.5z M15.1,9.8
                  //      c0-2.8-2.3-5.1-5.2-5.1C7.1,4.7,4.8,7,4.8,9.9c0,2.8,2.3,5.2,5.2,5.2C12.8,15,15.1,12.7,15.1,9.8z"/>
                  //    <path fill="${layers[l].color}" d="M9.9,13c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1C13,11.7,11.6,13,9.9,13z M8,9.9
                  //      c0,1,0.8,1.9,1.9,1.9c1.1,0,1.9-0.9,1.9-1.9c0-1-0.9-1.9-1.9-1.9C8.9,8,8,8.9,8,9.9z"/>
                  //  </g>
                  //  </svg>`;

                  const svgLabel = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               viewBox="0 0 95.3 39.6" enableBackground="new 0 0 95.3 39.6">
            <g>
              <path fill="${layers[l].color}" d="M57.1,10.4c0,5.2-4.3,9.4-9.5,9.4s-9.5-4.2-9.5-9.4s4.2-9.5,9.4-9.5C52.9,0.9,57.1,5.1,57.1,10.4z M39.4,10.3
                c0,4.5,3.7,8.3,8.2,8.3c4.6,0,8.3-3.7,8.3-8.2c0-4.6-3.7-8.3-8.3-8.3C43.1,2,39.4,5.8,39.4,10.3z"/>
              <path fill="${layers[l].color}" d="M47.6,3.9c3.5,0,6.4,2.8,6.4,6.4c0,3.5-2.9,6.3-6.3,6.3c-3.5,0-6.4-2.8-6.4-6.3S44.1,3.9,47.6,3.9z M52.8,10.2
                c0-2.8-2.3-5.1-5.2-5.1c-2.8,0-5.1,2.3-5.1,5.2c0,2.8,2.3,5.2,5.2,5.2C50.5,15.4,52.8,13.1,52.8,10.2z"/>
              <path fill="${layers[l].color}" d="M47.6,13.4c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1C50.7,12.1,49.3,13.4,47.6,13.4z M45.7,10.3
                c0,1,0.8,1.9,1.9,1.9c1.1,0,1.9-0.9,1.9-1.9s-0.9-1.9-1.9-1.9C46.6,8.4,45.7,9.3,45.7,10.3z"/>
            </g>
            <rect x="0.5" y="22.9" fill="none" stroke="none" stroke-miterlimit="10" width="94.3" height="16.2"/>
            </svg>`;

                  for (const m in objData) {
                    if (
                      objData[m].hasOwnProperty("lat") &&
                      objData[m].hasOwnProperty("lng")
                    ) {
                      if (!objData[m].label) {
                        objData[m].marker = null;
                      } else if (
                        layers[l].type.includes("marker") &&
                        layers[l].type.includes("label")
                      ) {
                        objData[m].marker = new window.google.maps.Marker({
                          // map: map,
                          position: new window.google.maps.LatLng(
                            parseFloat(objData[m]?.lat),
                            parseFloat(objData[m]?.lng)
                          ),
                          title: cleanString(objData[m]?.name),
                          label: {
                            text: cleanString(objData[m]?.name),
                            // className: "gm-label label-max",
                            className: "gm-label",
                            color: layers[l].color,
                            fontSize: layers[l].size,
                          },
                          icon: {
                            anchor: new window.google.maps.Point(50, 20),
                            url: `data:image/svg+xml;base64,${window.btoa(
                              svgLabel
                            )}`,
                            scaledSize: new window.google.maps.Size(
                              svgLabelSizeW,
                              svgLabelSizeH
                            ),
                          },
                          zIndex:
                            window.google.maps.Marker.MAX_ZINDEX +
                            Number(layers[l].id),
                          // optimized: false,
                        });
                      } else if (layers[l].type.includes("label")) {
                        objData[m].marker = new window.google.maps.Marker({
                          // map: map,
                          position: new window.google.maps.LatLng(
                            parseFloat(objData[m]?.lat),
                            parseFloat(objData[m]?.lng)
                          ),
                          label: {
                            text: cleanString(objData[m]?.name),
                            // className: "gm-label label-max",
                            className: "gm-label",
                            color: layers[l].color,
                            fontSize: layers[l].size,
                          },
                          icon: {
                            anchor: new window.google.maps.Point(50, 20),
                            url: svgTransparent,
                            scaledSize: new window.google.maps.Size(
                              svgLabelSizeW,
                              svgLabelSizeH
                            ),
                          },
                          zIndex:
                            window.google.maps.Marker.MAX_ZINDEX +
                            Number(layers[l].id),
                          // optimized: false,
                        });
                      } else {
                        objData[m].marker = new window.google.maps.Marker({
                          // map: map,
                          position: new window.google.maps.LatLng(
                            parseFloat(objData[m]?.lat),
                            parseFloat(objData[m]?.lng)
                          ),
                          title: cleanString(objData[m]?.name),
                          icon: {
                            anchor: new window.google.maps.Point(50, 20),
                            url: `data:image/svg+xml;base64,${window.btoa(
                              svgLabel
                            )}`,
                            scaledSize: new window.google.maps.Size(
                              svgLabelSizeW,
                              svgLabelSizeH
                            ),
                          },
                          zIndex:
                            window.google.maps.Marker.MAX_ZINDEX +
                            Number(layers[l].id),
                          // optimized: false,
                        });
                      }

                      if (layers[l].visible) {
                        objData[m]?.marker && objData[m].marker.setMap(map);
                      }

                      objData[m]?.marker &&
                        objData[m].marker.addListener("click", (e) => {
                          closeWindowHandler(layers, l);
                          const p1 = e.latLng.toJSON();
                          const objArr = [];
                          Object.keys(objData).forEach((d) => {
                            const p2 = {
                              lat: parseFloat(objData[d].lat),
                              lng: parseFloat(objData[d].lng),
                            };
                            getDistanceByKm(p1, p2) <= 5 &&
                              objArr.push(objData[d]);
                          });

                          const uniqueLocations = objArr
                            .map((obj) => obj.name)
                            .filter((o, i, a) => a.indexOf(o) === i);

                          const multiLocations = {};
                          uniqueLocations.forEach(function (location) {
                            multiLocations[location] = objArr.filter(function (
                              obj
                            ) {
                              return obj.name === location;
                            });
                          });

                          // console.log(allEqual(Object.keys(multiLocations)));

                          const clusterContent = [
                            '<div class="gm-card gm-card-locations">',
                          ];
                          Object.keys(multiLocations).forEach((loc) => {
                            clusterContent.push('<div class="location">');
                            clusterContent.push(
                              '<h3 class="title color-primary">' + loc + "</h3>"
                            );
                            multiLocations[loc].forEach((o) => {
                              clusterContent.push(
                                '<p><a href="' +
                                  o?.link +
                                  '" target="_blank">' +
                                  o?.funding +
                                  "</a></p>"
                              );
                            });
                            clusterContent.push("</div>");
                          });

                          clusterContent.push("</div>");

                          layers[l].windows = new window.google.maps.InfoWindow(
                            {
                              content: clusterContent.join(""),
                              position: e.latLng,
                              pixelOffset: new window.google.maps.Size(
                                -2.5,
                                -20
                              ),
                              disableAutoPan: false,
                              zIndex:
                                window.google.maps.Marker.MAX_ZINDEX +
                                Number(layers[l].id),
                            }
                          );

                          layers[l].windows.open({ map, shouldFocus: false });
                        });
                    }
                  }

                  layers[l].data = objData;
                })
                .catch((error) => {
                  console.error(error);
                });

              break;
            case "layerPa":
              ////
              break;
            case "layerGl":
              fetch(API, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  query: `
                        query MyQuery {
                          geomap {
                            geoLayers {
                              layerGl {
                                name
                                lat
                                lng
                                size
                              }
                            }
                          }
                        }                
                      `,
                }),
              })
                .then((response) => response.json())
                .then((response) => {
                  const arrData = response.data.geomap.geoLayers.layerGl;
                  const objData = Object.assign({}, arrData);

                  for (const m in objData) {
                    if (
                      objData[m].hasOwnProperty("lat") &&
                      objData[m].hasOwnProperty("lng")
                    ) {
                      objData[m].marker = new window.google.maps.Marker({
                        map: map,
                        position: new window.google.maps.LatLng(
                          parseFloat(objData[m]?.lat),
                          parseFloat(objData[m]?.lng)
                        ),
                        label: {
                          text: cleanString(objData[m]?.name),
                          className: "gm-label-general",
                          color: layers[l].color,
                          fontSize: objData[m].hasOwnProperty("size")
                            ? objData[m].size + "px"
                            : layers[l].size,
                        },
                        icon: {
                          url: svgTransparent,
                          scaledSize: new window.google.maps.Size(
                            svgSize,
                            svgSize
                          ),
                        },
                        zIndex:
                          window.google.maps.Marker.MAX_ZINDEX +
                          Number(layers[l].id),
                        // optimized: false,
                      });
                    }
                  }

                  layers[l].data = objData;
                })
                .catch((error) => {
                  console.error(error);
                });
              break;
            default:
              break;
          }
        }
        setLayers({ ...layers });
      }
    }
  }, [map, setLayers]);

  React.useEffect(() => {
    layers && Object.keys(layers).length !== 0 && setWaiting(false);
  }, [layers, setWaiting]);

  return (
    <>
      {waiting ? (
        <Spinner />
      ) : (
        <>
          <div ref={ref} style={style} />
          {React.Children.map(children, (child) => {
            if (React.isValidElement(child)) {
              // set the map prop on the child component
              return React.cloneElement(child, { map });
            }
          })}
        </>
      )}
    </>
  );
};

// const infoWindow = new google.maps.InfoWindow();

// window.google.maps.event.addListener(_markerCluster, 'clusterclick', (cluster, event) => {
//     if (cluster.getMarkers().length > 1) {
//       const markers = cluster.getMarkers();
//       let isOverlappedCluster = true;

//       markers.slice(1).reduce((prevMarker, marker) => {
//         if (marker.getPosition().equals(prevMarker.getPosition()) === false) {
//           isOverlappedCluster = false;
//         }

//         return marker;
//       }, markers[0]);

//       if (isOverlappedCluster) {
//         infoWindow.setContent('markers info...');
//         infoWindow.setPosition(cluster.getCenter());
//         infoWindow.open(gmap);
//       }
//     }

const Marker = (options) => {
  const [marker, setMarker] = React.useState();

  React.useEffect(() => {
    if (!marker) {
      setMarker(new window.google.maps.Marker());
    }

    // remove marker from map on unmount
    return () => {
      if (marker) {
        marker.setMap(null);
      }
    };
  }, [marker]);

  React.useEffect(() => {
    if (marker) {
      marker.setOptions(options);
    }
  }, [marker, options]);

  return null;
};

const deepCompareEqualsForMaps = createCustomEqual((deepEqual) => (a, b) => {
  if (
    isLatLngLiteral(a) ||
    a instanceof window.google.maps.LatLng ||
    isLatLngLiteral(b) ||
    b instanceof window.google.maps.LatLng
  ) {
    return new window.google.maps.LatLng(a).equals(
      new window.google.maps.LatLng(b)
    );
  }

  // use fast-equals for other objects
  return deepEqual(a, b);
});

function useDeepCompareMemoize(value) {
  const ref = React.useRef();

  if (!deepCompareEqualsForMaps(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}

function useDeepCompareEffectForMaps(callback, dependencies) {
  React.useEffect(callback, dependencies.map(useDeepCompareMemoize));
}

export default App;
